import * as React from "react"

import { cn } from "@/lib/utils"

interface LoadingStateProps {
  label: React.ReactNode
  className?: string
  spinnerClassName?: string
  labelClassName?: string
}

const LoadingState = ({
  label,
  className,
  spinnerClassName,
  labelClassName,
}: LoadingStateProps) => (
  <div
    className={cn("flex flex-col items-center justify-center gap-4 py-32", className)}
    role="status"
    aria-live="polite"
  >
    <div
      aria-hidden="true"
      className={cn(
        "size-12 animate-spin rounded-full border-4 border-primary border-t-transparent",
        spinnerClassName
      )}
    />
    <p className={cn("font-display text-xl tracking-widest text-muted-foreground", labelClassName)}>
      {label}
    </p>
  </div>
)

export { LoadingState }
